// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"33498b5b","584":"f56d10ab"}[chunkId] + ".chunk.css";
};